export default "/images/press3.png?03b078433399df260adf0796dd113e18";